// Pola <input type="date"> (data bez godziny) w oknie metadanych raportu.
// Wartość z API: "RRRR-MM-DDT00:00:00" bez strefy, czytana jako czas lokalny.

// Do pola: "yyyy-mm-dd" z 4-cyfrowym rokiem. Podczas wpisywania roku przeglądarka zgłasza np. "0002-08-11";
// bez dopełnienia roku i przy Invalid Date pole było czyszczone (SR-028).
export const toDateInputValue = (value?: Date | string | null) => {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "";
  const year = String(d.getFullYear()).padStart(4, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Z pola: północ UTC wybranego dnia, więc JSON wysyła "RRRR-MM-DDT00:00:00.000Z" i backend zapisuje ten sam dzień.
// Lokalna północ (new Date(y, m - 1, d)) szła jako poprzedni dzień 23:00 (latem 22:00) UTC i po zapisie data
// cofała się o dzień (błąd od 22.10.2026).
export const fromDateInputValue = (value: string): Date | null => {
  const [y, m, d] = value.split("-").map(Number);
  if (!y || !m || !d) return null;
  const date = new Date(Date.UTC(y, m - 1, d));
  date.setUTCFullYear(y); // Date.UTC mapuje lata 0-99 na 1900+
  return date;
};
